export default {
    'PTRC': [ 'B_Cells',
            'Plasma_cells',
            'T_CD8',
            'T_FH',
            'Tregs',
            'T_CD4',
            'NK_Cells',
            'Mast_Cells',
            'Eosinophils',
            'Monocytes',
            'Neutrophils',
            'Dendritic',
            'Macrophages',
            'Keratinocytes',
            'Adipose',
            'Endothelial',
            'CAFs',
            'Tumor'],
    'PCC': [ 'B_Cells',
            'Plasma_cells',
            'T_CD8',
            'T_FH',
            'Tregs',
            'T_CD4',
            'NK_Cells',
            'Mast_Cells',
            'Eosinophils',
            'Monocytes',
            'Neutrophils',
            'Dendritic',
            'Macrophages',
            'Keratinocytes',
            'Adipose',
            'Endothelial',
            'CAFs',
            'Tumor'],
}